import React, { Component } from 'react';
import TaxLine from './TaxLine';
import getTax from '../service/AtoTaxService';
import "./TaxTable.scss";

class TaxTable extends Component {
    constructor() {
        super();

        this.state = {
            taxRecords:[]
        };
    }

    componentDidMount() {
        this.loadTaxTableData();
    }

    loadTaxTableData() {
        var taxRecords = [];
        for (var amt = 10000; amt <= 200000; amt += 1000) {
            var taxInfo = getTax(amt);

            taxRecords.push(taxInfo);

            // taxRecords.push({
            //     amount: amt,
            //     tax: taxInfo.tax,
            //     real: amt - taxInfo.tax,
            //     category: taxInfo.category,
            //     marginalTaxRate: taxInfo.marginalTaxRate 
            // });
        }
        this.setState({ taxRecords : taxRecords });
    }

    // var listItems = this.taxRecords.map((item) => {
    //     // console.log(item)
    //     <div>abc</div>
    //   });

    render() {
        return (
            <div className="tax-table">
                <div className="tax-line">
                    <div className="amount">Annual Taxable Income</div>
                    <div className="tax">Tax</div>
                    <div className="after-tax">Income after Tax</div>
                    <div className="margin-tax-rate">Marginal Tax Rate</div>
                </div>
                {this.state.taxRecords.map((taxRecord) => (
                <TaxLine
                    key={taxRecord.income}
                    {...taxRecord}></TaxLine>
                ))}
            </div>
        );
    }

}

export default TaxTable;
